// extracted by mini-css-extract-plugin
export default {"UploadPage":"UploadPage_UploadPage__YfmDn","Content":"UploadPage_Content__xuDUq","GoBack":"UploadPage_GoBack__AfDZx"};